import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { ErrorDisplay } from '@confluence/error-boundary';

import type {
	AIDescriptionButtonWrapperQuery as AIDescriptionButtonWrapperQueryType,
	AIDescriptionButtonWrapperQueryVariables,
} from './__types__/AIDescriptionButtonWrapperQuery';

type UseAIDescriptionProps = {
	spaceId: string;
	linkResourceType: string;
};

type UseAIDescriptionReturnType = {
	data?: AIDescriptionButtonWrapperQueryType;
	loading: boolean;
	errorComponent?: JSX.Element;
};

export const useAIDescription = ({
	spaceId,
	linkResourceType,
}: UseAIDescriptionProps): UseAIDescriptionReturnType => {
	const { data, loading, error } = useQuery<
		AIDescriptionButtonWrapperQueryType,
		AIDescriptionButtonWrapperQueryVariables
	>(
		// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Experimental Schema GraphQL Operation
		gql`
			query AIDescriptionButtonWrapperQuery($spaceId: ID!) {
				space(id: $spaceId) {
					homepageId
				}
			}
		`,
		{
			skip: linkResourceType !== 'space',
			variables: {
				spaceId,
			},
		},
	);

	let errorComponent: undefined | JSX.Element = undefined;
	if (error && !loading) {
		errorComponent = <ErrorDisplay error={error} />;
	}

	return { data, loading, errorComponent };
};
